import { useState } from "react";
import SelectInputContainer from "../SelectInputContainer/SelectInputContainer";
import TextInputContainer from "../TextInputContainer/TextInputContainer";
import TextAreaInputContainer from "../TextAreaInputContainer/TextAreaInputContainer";
import SwitchInputConainer from "../SwitchInputConainer/SwitchInputConainer";
import TabInputConatiner from "../TabInputConatiner/TabInputConatiner";
import ImageInputContainer from "../ImageInputContainer/ImageInputContainer";
import TextInputContainerNumber from "../TextInputContainerNumber/TextInputContainerNumber";

const InputsContainer = (props) => {
  const [value, setValue] = useState("");
  switch (props.data.type) {
    case "select":
      return <SelectInputContainer data={props.data} />;
    case "text":
      return <TextInputContainer data={props.data} />;
    case "number":
      return <TextInputContainerNumber data={props.data} />;
    case "textarea":
      return <TextAreaInputContainer data={props.data} />;
    case "switch":
      return <SwitchInputConainer data={props.data} />;
    case "radio":
      return <TabInputConatiner data={props.data} />;
    case "image":
      return <ImageInputContainer data={props.data} />;
    default:
      return <></>;
  }
};

export default InputsContainer;
